import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";

import { DEFAULT_LOCALE, TRANSLATIONS_API } from "src/config";

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: DEFAULT_LOCALE,
    fallbackLng: DEFAULT_LOCALE,
    interpolation: {
      escapeValue: false
    },
    keySeparator: false,
    nsSeparator: false,
    backend: {
      loadPath: (lngs: string) => {
        return `${TRANSLATIONS_API}/${lngs}`;
      },
      parse: (data: string) => {
        return JSON.parse(data).reduce(
          (
            acc: { [name: string]: string },
            { content, translation_key: { name } }: { content: string; translation_key: { name: string } }
          ) => ({
            ...acc,
            [name]: content
          }),
          {}
        );
      }
    }
  });

export default i18n;
